import React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import carIcon from "../../assets/fi_car.svg";
import iconFile from "../../assets/fi_file-text.svg";
import iconSettings from "../../assets/fi_settings.svg";
import {useAuth} from "../../context/AuthContext";

function MenuItems({ onCloseMenu }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();

    const handleClick = (route) => {
        navigate(route);
        onCloseMenu();
    };

    if (!user) {
        return null;
    }

    const isActive = (path) => location.pathname === path;

    return (
        <div className={'userMenuButtons__top'}>
            <div className="userMenuButtons">
                <div
                    className={`userMenuButtons__item ${isActive('/order') ? 'active' : ''}`}
                    onClick={() => handleClick('/order')}
                >
                    <img className="userMenuContainer__header--icon" src={carIcon} alt="ico-car"/>
                    <label>Užsisakyti</label>
                </div>
                <div
                    className={`userMenuButtons__item ${isActive('/history') ? 'active' : ''}`}
                    onClick={() => handleClick('/history')}
                >
                    <img className="userMenuContainer__header--icon" src={iconFile} alt="ico-file"/>
                    <label>Kelionės</label>
                </div>
                <div
                    className={`userMenuButtons__item ${isActive('/profile') ? 'active' : ''}`}
                    onClick={() => handleClick('/profile')}
                >
                    <img className="userMenuContainer__header--icon" src={iconSettings} alt="ico-settings"/>
                    <label>Nustatymai</label>
                </div>
            </div>
        </div>
    );
}

export default MenuItems;
